import { render, staticRenderFns } from "./ComparisonPlanTableParts.vue?vue&type=template&id=7a7bffc3&scoped=true"
import script from "./ComparisonPlanTableParts.vue?vue&type=script&lang=ts"
export * from "./ComparisonPlanTableParts.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonPlanTableParts.vue?vue&type=style&index=0&id=7a7bffc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7bffc3",
  null
  
)

export default component.exports